<div class="table-container">
  <table>
    <ng-content select="[table-head]" />
    <ng-content select="[table-body]" />
  </table>
</div>
